<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    width="30%"
    :before-close="handleClose">
    <span>{{message}}</span>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button v-for="(item, index) in button_list" :key="index" :type="item.type" @click="onConfirm(item)">{{item.name}}</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "ErpConfirm",
  data() {
    return {
      dialogVisible: false,
      title: "",
      message: "",
      button_list:[],
      callback:null
    };
  },
  methods:{
    show({title, content, button_list},callback){
      this.title = title;
      this.message = content;
      this.button_list = button_list;
      this.dialogVisible = true;
      this.callback = callback;
    },
    onConfirm(item){
      typeof this.callback=== 'function' && this.callback(item);
      this.dialogVisible = false;
    },
    handleClose(done) {
      this.$emit("close", done);
      if (this.callback) {
        this.callback=null
      }
      this.dialogVisible = false;
    }
  }
}
</script>

<style lang="scss" scoped>
.el-button--primary, .el-button--danger ,.el-button--success,.el-button--warning{
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Common/ErpConfirm.vue